import { readerStoryHeroCoverAttrs, readerHeroCoverAttrsFromPublicPath } from "../../lib/responsive-story-images.js";
import LlAudioSearchCombo from "./ll-audio-search-combo.marko";
import LlStoryReaderLocaleText from "./ll-story-reader-locale-text.marko";
import { pickReaderTaglineText } from "../../lib/reader-tagline.js";
import { buildLinkedParagraphInnerHtml, buildParagraphInnerHtml } from "../../lib/story-sentence-html.js";
import {
  storyReaderBackLinkFullMeta,
  storyReaderDisplayTaglineMeta,
  storyReaderDisplayTitleAidMeta,
  storyReaderDisplayTitleMeta,
} from "../../lib/locale-strings-debug.js";
import LlReaderPdfBtn from "./ll-reader-pdf-btn.marko";
import LlReaderPdfCard from "./ll-reader-pdf-card.marko";
import {
  READER_AUDIO_BOTTOM_OPT_OUT_SCRIPT,
  readerWrapClassNames,
} from "../../lib/reader-bottom-audio-ssr.js";
import { inlineCriticalFontsAndCssEnabled } from "../../lib/inline-critical-assets.js";
import ReaderShell from "./reader/reader-shell.marko";
import { endingPreviewText } from "../../lib/ending-preview.js";
import CoursePromoStrip from "./course-promo-strip.marko";
import ReaderMainTail from "./reader/reader-main-tail.marko";
import ReaderDataScripts from "./reader/reader-data-scripts.marko";
import LlReaderImageStagePlay from "./ll-reader-image-stage-play.marko";
import { buildStoryReaderTextData } from "../../lib/reader-text-data-builders.js";

<if=!input.data.story>
  <div class="container">
    <div class="empty">
      <div class="empty__icon">📖</div>
      <p class="empty__title">${input.data.notFoundTitle}</p>
      <a href=input.data.basePath class="btn btn--outline" style="margin-top:var(--space-md)">← ${input.data.backLabel}</a>
    </div>
  </div>
</if>
<else>
  <ReaderShell
    wrapClass=readerWrapClassNames({ hasAudio: !!(input.data.storyAudioSrc || "").trim() })
    audioBottomOptOutScript=READER_AUDIO_BOTTOM_OPT_OUT_SCRIPT
    contentKind="story"
    contentId=(input.data.branchingStoryScene && input.data.branchingStoryScene.scene && input.data.branchingStoryScene.scene.contentId
      ? input.data.branchingStoryScene.scene.contentId
      : (input.data.story.contentId || ""))
    hasAudio=!!(input.data.storyAudioSrc || "").trim()
    searchPlaceholder=(input.data.textTools?.labels?.searchPlaceholder || "")
    searchAriaLabel=(input.data.textTools?.labels?.textSearchAriaLabel || "")
    wordInfoEmptyLabel=(input.data.wordInfoEmptyLabel || "")
  >
        <div class="ll-reader-top-bar">
          <a class="ll-reader-back-link" href=(input.data.branchingStoryScene ? input.data.branchingStoryScene.storiesBasePath : input.data.basePath)>
            <if=input.data.branchingStoryScene>
              ← ${
                input.data.branchingStoryScene.scene.targetTitle ||
                  input.data.branchingStoryScene.scene.title ||
                  input.data.story.targetTitle ||
                  input.data.story.title ||
                  input.data.allLabel
              }
            </if>
            <else>
              <LlStoryReaderLocaleText
                text=("← " + (input.data.allLabel || ""))
                meta=storyReaderBackLinkFullMeta(
                  input.data,
                  input.data.textTools?.uiLang || "en",
                )
              />
            </else>
          </a>
          <if=input.data.pdfUrl>
            <LlReaderPdfBtn
              pdfUrl=input.data.pdfUrl
              title=input.data.downloadPdfLabel
              ariaLabel=input.data.downloadPdfAriaLabel
              label=input.data.pdfAbbrevLabel
              deferredReveal=true
            />
          </if>
        </div>

        <if=(!input.data.branchingStoryScene && (input.data.story.learnerTitle || input.data.story.translatedTitle))>
          <p class="title-aid title-aid--detail">
            <LlStoryReaderLocaleText
              text=(input.data.story.learnerTitle || input.data.story.translatedTitle)
              meta=storyReaderDisplayTitleAidMeta(
                input.data.story,
                input.data.textTools?.uiLang || "en",
                input.data.textTools?.targetLang || input.data.story.language || "de",
              )
            />
          </p>
        </if>
        <div class="reader-title-row">
          <h1 class="reader-title">
            <LlStoryReaderLocaleText
              text=(
                input.data.branchingStoryScene && input.data.branchingStoryScene.scene
                  ? (
                      input.data.branchingStoryScene.scene.targetTitle ||
                      input.data.branchingStoryScene.scene.title ||
                      input.data.story.targetTitle ||
                      input.data.story.title
                    )
                  : (input.data.story.targetTitle || input.data.story.title)
              )
              meta=storyReaderDisplayTitleMeta(
                input.data.branchingStoryScene && input.data.branchingStoryScene.scene
                  ? input.data.branchingStoryScene.scene
                  : input.data.story,
                input.data.textTools?.uiLang || "en",
                input.data.textTools?.targetLang || input.data.story.language || "de",
              )
            />
          </h1>
        </div>
        <if=(input.data.story.level || pickReaderTaglineText(input.data.story))>
          <div class="reader-desc-line">
            <if=input.data.story.level>
              <span class=["badge", "reader-desc-level", `badge--${(input.data.story.level || '').toLowerCase()}`]>${input.data.story.level}</span>
            </if>
            <if=pickReaderTaglineText(input.data.story)>
              <p class="reader-desc reader-desc--plain reader-desc--inline">
                <LlStoryReaderLocaleText
                  text=pickReaderTaglineText(input.data.story)
                  meta=storyReaderDisplayTaglineMeta(
                    input.data.story,
                    input.data.textTools?.uiLang || "en",
                    input.data.textTools?.targetLang || input.data.story.language || "de",
                  )
                />
              </p>
            </if>
          </div>
        </if>

        <if=(input.data.branchingStoryScene && input.data.branchingStoryScene.sceneImagePath)>
          <for|hero| of=[readerHeroCoverAttrsFromPublicPath(input.data.branchingStoryScene.sceneImagePath)]>
            <div class="ll-story-hero ll-story-hero--reader-compact ll-story-hero--scene" id="ll-story-hero" style="aspect-ratio:21/6">
              <div class="ll-story-hero__frame">
                <img
                  class="ll-story-hero__img"
                  src=hero.src
                  srcset=hero.srcSet
                  sizes=hero.sizes
                  alt=(input.data.branchingStoryScene.scene.targetTitle || input.data.branchingStoryScene.scene.title || "")
                  width=hero.width
                  height=hero.height
                  loading="eager"
                  fetchpriority="high"
                  decoding="sync"
                  onError="this.style.display='none';this.parentElement.innerHTML='<div class=&quot;ll-story-hero__fallback&quot;>📖</div>'"
                >
                <LlReaderImageStagePlay modifierClass="ll-reader-image-stage-play--main" ariaLabel=(input.data.audioPlayLabel || "Play audio")/>
              </div>
            </div>
          </for>
        </if>
        <else>
          <for|hero| of=[readerStoryHeroCoverAttrs(input.data.story)]>
            <div class="ll-story-hero ll-story-hero--reader-compact" id="ll-story-hero" style=(input.data.branchingStoryScene ? "display:none" : "aspect-ratio:21/6")>
              <div class="ll-story-hero__frame">
                <img
                  class="ll-story-hero__img"
                  src=hero.src
                  srcset=hero.srcSet
                  sizes=hero.sizes
                  alt=(input.data.story.targetTitle || input.data.story.title)
                  width=hero.width
                  height=hero.height
                  loading="eager"
                  fetchpriority="high"
                  decoding="sync"
                  onError="this.style.display='none';this.parentElement.innerHTML='<div class=&quot;ll-story-hero__fallback&quot;>📖</div>'"
                >
                <LlReaderImageStagePlay modifierClass="ll-reader-image-stage-play--main" ariaLabel=(input.data.audioPlayLabel || "Play audio")/>
              </div>
            </div>
          </for>
        </else>

        <div class="ll-reader-audio-dock-row">
          <div class="ll-reader-audio-dock" id="ll-reader-audio-dock">
            <if=!!(input.data.storyAudioSrc || "").trim()>
              <LlAudioSearchCombo
                showSearch=false
                audioSrc=(input.data.storyAudioSrc || "")
                audioDurationHint=(input.data.storyAudioDurationHint != null ? input.data.storyAudioDurationHint : "")
                audioDebug=(
                  input.data.storyAudioSrc
                    ? ""
                    : (input.data.branchingStoryScene
                        ? (input.data.audioNoSourceDebugFallbackScene || input.data.audioNoSourceDebugFallback || "")
                        : (input.data.audioNoSourceDebugFallbackStory || input.data.audioNoSourceDebugFallback || ""))
                )
                audioTitle=(input.data.audioBadgeLabel || "")
                audioAriaLabel=(input.data.audioBadgeLabel || "")
                scrollFollowTitle=(input.data.scrollFollowTitle || "")
                scrollFollowAriaLabel=(input.data.scrollFollowAriaLabel || "")
              />
            </if>
          </div>
          <div class="ll-reader-voice-toggle-host" id="ll-reader-voice-toggle-host" hidden></div>
        </div>

        <div class="ll-meter-warning" id="ll-meter-warning" style="display:none">
          <span class="ll-meter-warning__text">${input.data.premiumGate?.labels?.meter?.warningBanner || ""}</span>
          <a
            class="ll-meter-warning__cta js-ll-purchase-cta"
            href="#"
            data-ll-analytics="0"
            data-ll-product=(input.data.premiumGate?.paywallPlans?.lern?.yearly?.plan?.product)
            data-ll-euros=(input.data.premiumGate?.paywallPlans?.lern?.yearly?.plan?.euros)
            data-ll-period=(input.data.premiumGate?.paywallPlans?.lern?.yearly?.plan?.period)
            data-ll-tier=(input.data.premiumGate?.paywallPlans?.lern?.yearly?.plan?.tier)
            data-ll-audience="lern"
            data-ll-pricing-tier-id=(input.data.premiumGate?.paywallPlans?.tierId)
          >${input.data.premiumGate?.labels?.meter?.ctaGuest || input.data.premiumGate?.labels?.meter?.cta || ""}</a>
        </div>

        <div id="ll-meter-inline-host"></div>

        <if=(input.data.branchingStoryScene && (input.data.branchingStoryScene.dialogRows || []).length)>
          <div class="reader-text ll-branching-scene-script" id="ll-text-root" data-ll-text-root>
            <for|row| of=(input.data.branchingStoryScene.dialogRows || [])>
              <if=(row.kind === "narration")>
                <p>$!{row.textHtml || row.text}</p>
              </if>
              <else>
                <div class=["dialog-line", row.align === "right" ? "dialog-line--pull-right" : "dialog-line--pull-left"]>
                  <if=(row.speaker)><span class="dialog-line__name">${row.speaker}</span></if>
                  <if=(row.textHtml)>
                    <div class="dialog-line__text">$!{row.textHtml}</div>
                  </if>
                  <else>
                    <div class="dialog-line__text">${row.text}</div>
                  </else>
                </div>
              </else>
            </for>
          </div>
        </if>
        <else>
          <div class="reader-text" id="ll-text-root" data-ll-text-root>
            <for|para, paraIdx| of=(Array.isArray(input.data.story.text) ? input.data.story.text : [])>
              <p>$!{buildLinkedParagraphInnerHtml(input.data.storyScript, paraIdx, { lean: inlineCriticalFontsAndCssEnabled() }) || buildParagraphInnerHtml(
                  String(para || ""),
                  (input.data.storyTimestamps || [])[paraIdx] || null,
                )}</p>
            </for>
          </div>
        </else>

        <if=input.data.branchingStoryScene>
          <if=((input.data.branchingStoryScene.sceneChoices || []).length)>
            <section class="ll-ending-unit" id="ll-branching-scene-choices">
              <h2 class="ll-unit-title ll-unit-title--centered">
                ${
                  (input.data.branchingStoryScene.sceneChoices || []).length === 1
                    ? input.data.branchingStoryScene.continueSingleLabel
                    : input.data.branchingStoryScene.continueMultipleLabel
                }
              </h2>
              <div
                class=[
                  "ll-ending-icon",
                  (input.data.branchingStoryScene.sceneChoices || []).length === 1
                    ? "ll-ending-icon--stem"
                    : "",
                ]
                aria-hidden="true"
              >${
                (input.data.branchingStoryScene.sceneChoices || []).length === 1 ? "" : "Y"
              }</div>
              <div
                class=[
                  "ll-ending-buttons",
                  (input.data.branchingStoryScene.sceneChoices || []).length === 1
                    ? "ll-ending-buttons--single"
                    : "",
                ]
              >
                <for|ch, idx| of=(input.data.branchingStoryScene.sceneChoices || [])>
                  <a
                    href=ch.href
                    data-ll-premium-open=(ch.requiresPremium ? "chapter" : null)
                    class=[
                      "ll-surface-card",
                      "ll-unit-card",
                      "ll-ending-btn",
                      (input.data.branchingStoryScene.sceneChoices || []).length === 1
                        ? "ll-ending-btn--single"
                        : idx === 0
                          ? "ll-ending-btn--left"
                          : idx === 1
                            ? "ll-ending-btn--right"
                            : "",
                    ]
                  >
                    <if=ch.image>
                      <span class="ll-ending-btn__media">
                        <img class="ll-ending-btn__image" src=ch.image alt="" loading="lazy" decoding="async"/>
                      </span>
                    </if>
                    <span class="ll-ending-btn__text">
                      <span class="ll-unit-card__title">${ch.text}</span>
                      <if=ch.requiresPremium><span class="badge badge--premium">Premium</span></if>
                    </span>
                  </a>
                </for>
              </div>
            </section>
          </if>
          <else-if=input.data.branchingStoryScene.isTerminal>
            <section class="ll-branching-scene-end card" id="ll-branching-scene-end">
              <div class="ll-branching-scene-end__card-body">
                <h2 class="ll-branching-scene-end__title">${input.data.branchingStoryScene.endTitle}</h2>
                <div class="ll-branching-scene-end__stats" id="ll-branching-scene-end-stats"></div>
                <a href=input.data.branchingStoryScene.storiesBasePath class="btn btn--outline">${input.data.branchingStoryScene.classicBackOverviewLabel}</a>
              </div>
            </section>
          </else-if>
          <else>
            <div class="ll-branching-scene-end ll-branching-scene-end--fallback" style="margin-top:var(--space-xl)">
              <a href=input.data.branchingStoryScene.storiesBasePath class="btn btn--outline">${input.data.branchingStoryScene.classicBackOverviewLabel}</a>
              <p class="ll-branching-scene-end__hint">${input.data.branchingStoryScene.classicEndSceneLabel}</p>
            </div>
          </else>
        </if>

        <if=(!input.data.branchingStoryScene && (input.data.endingChoices || []).length >= 2)>
          <section class="ll-ending-unit" id="ll-ending-unit">
            <h2 class="ll-unit-title ll-unit-title--centered">${input.data.chooseEndingLabel || ""}</h2>
            <div class="ll-ending-icon" aria-hidden="true">Y</div>
            <div class="ll-ending-buttons">
              <for|ending, idx| of=(input.data.endingChoices || []).slice(0, 2)>
                <button
                  type="button"
                  class=["ll-surface-card", "ll-unit-card", "ll-ending-btn", idx === 0 ? "ll-ending-btn--left" : "ll-ending-btn--right"]
                  data-ending-id=ending.id
                  data-ending-title=(ending.title || ending.label || "")
                  data-ending-text=ending.text
                >
                  <if=(ending.image)>
                    <span class="ll-ending-btn__media">
                      <img
                        class="ll-ending-btn__image"
                        src=(ending.image)
                        srcset=(ending.btnSrcSet)
                        sizes=(ending.btnSizes)
                        alt=""
                        width=(ending.imageWidth)
                        height=(ending.imageHeight)
                        loading="lazy"
                        decoding="sync"
                      />
                    </span>
                  </if>
                  <span class="ll-ending-btn__text" data-ending-text=ending.text>
                    <span class="ll-unit-card__title">${ending.label || ending.title || ending.id}</span>
                    <if=ending.text>
                      <span class="ll-ending-btn__preview">${endingPreviewText(ending.text)}</span>
                    </if>
                  </span>
                </button>
              </for>
            </div>
            <div class="ll-ending-result" id="ll-ending-result" style="display:none">
              <p class="ll-ending-result__label" id="ll-ending-result-label">${input.data.endingChosenLabel || ""}</p>
              <h3 class="ll-ending-result__title" id="ll-ending-result-title"></h3>
              <div class="ll-ending-result__controls" id="ll-ending-result__controls">
                <LlAudioSearchCombo
                  showSearch=false
                  audioButtonId="ll-ending-audio-btn"
                  audioSrc=""
                  audioTitle=(input.data.audioBadgeLabel || "")
                  audioAriaLabel=(input.data.audioBadgeLabel || "")
                  scrollFollowTitle=(input.data.scrollFollowTitle || "")
                  scrollFollowAriaLabel=(input.data.scrollFollowAriaLabel || "")
                />
              </div>
              <div class="ll-ending-result__text" id="ll-ending-result-text">
                $!{input.data.endingsPanelsHtml || ""}
              </div>
            </div>
          </section>
        </if>

        <LlReaderPdfCard pdfUrl=input.data.pdfUrl uiLang=input.data.textTools?.uiLang/>

        <ReaderMainTail
          data=input.data
          includeSecondEndingPromoHost=true
        />
        <CoursePromoStrip class="ll-course-strip--reader"/>
  </ReaderShell>

  <ReaderDataScripts payload=buildStoryReaderTextData(input.data)/>
  <if=input.data.branchingStoryScene>
    <html-script id="ll-branching-story-scene-data" type="application/json">
      $!{JSON.stringify({
        ...(input.data.branchingStoryScene.storyStats || {}),
        scenesDiscoveredTemplate: input.data.branchingStoryScene.scenesDiscoveredTemplate || "",
        endingsCountTemplate: input.data.branchingStoryScene.endingsCountTemplate || "",
        exercisesCountTemplate: input.data.branchingStoryScene.exercisesCountTemplate || "",
      })}
    </html-script>
    <html-script src="/js/branching-story-scene-client.js" defer></html-script>
  </if>

  <if=input.data.premiumGate>
    <html-script type="application/ld+json">
      $!{JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Article",
        "headline": input.data.story.targetTitle || input.data.story.title || "",
        "description": pickReaderTaglineText(input.data.story) || input.data.story.translatedDescription || input.data.story.description || "",
        "isAccessibleForFree": !input.data.premiumGate.blocked,
        "hasPart": [
          {
            "@type": "WebPageElement",
            "isAccessibleForFree": true,
            "cssSelector": "#ll-text-root"
          },
          {
            "@type": "WebPageElement",
            "isAccessibleForFree": !(input.data.premiumGate.lockExercises),
            "cssSelector": "#ll-exercises-unit"
          }
        ]
      })}
    </html-script>
  </if>
  </else>
